import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Launcher from "./Launcher";
import Onboarding from "./page/Onboarding";
import SignUp from "./page/Signup";
import Auth from "./page/Auth";
import UploadImage from "./page/uploadImage";
import CreateUsername from "./page/UserName";
import Addname from "./page/FullName";
import MainChat from "./page/MainChat";
import Verify from "./page/verifyMail";
import { io, Socket } from "socket.io-client";

function App() {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        new Notification("Notification permission granted!");
      } else {
        new Notification("Notification permission denied.");
      }
    });
  }, []);

  setTimeout(() => {
    setPageLoading(false);
  }, 5000);

  return (
    <>
      {pageLoading ? (
        <>
          <Launcher />
        </>
      ) : (
        <>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Onboarding />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<Auth />} />
              <Route path="/upload-profile-picture" element={<UploadImage />} />
              <Route path="/username" element={<CreateUsername />} />
              <Route path="/add-name" element={<Addname />} />
              <Route path="/chat" element={<MainChat />} />
              <Route path="/verify" element={<Verify />} />
            </Routes>
          </BrowserRouter>
        </>
      )}
    </>
  );
}

export default App;
